import React from "react";

const Icon = ({ i, style }: { i: string, style?: React.CSSProperties }) => <span className={`choir-${i}`} style={style} />;

export default Icon;
